import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/areas-served/$city")({
  component: () => <Outlet />,
});